export default "__VITE_ASSET__D4Vz5X1Z__"